import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  skypointProjectLoading: false,
  skypointProject: [],
  skypointProjectCount: 0,
  skypointProjectTotalCount: 0,
  skypointProjectStatus: [],
  // The board, one column per status: { [statusId]: { tasks, count, page, loading } }. Each
  // column is paged on its own (page "all" stops at 200 tasks, OD-1694).
  skypointBoard: {},
};

export const skypointProject = createSlice({
  name: "skypointProject",
  initialState,
  reducers: {
    setSkypointProjectLoading(state, action) {
      return {
        ...state,
        skypointProjectLoading: action?.payload,
      };
    },
    setSkypointProject(state, action) {
      return {
        ...state,
        skypointProjectLoading: false,
        skypointProject: action?.payload?.tasks,
        skypointProjectCount: action?.payload?.count,
        skypointProjectTotalCount: action?.payload?.totalCount,
      };
    },
    setSkypointProjectStatus(state, action) {
      return {
        ...state,
        skypointProjectStatus: action?.payload?.statuses,
      };
    },
    setSkypointBoardColumnLoading(state, action) {
      const { status, loading } = action?.payload || {};
      const column = state.skypointBoard[status] || { tasks: [], count: 0, page: 0 };
      return {
        ...state,
        skypointBoard: { ...state.skypointBoard, [status]: { ...column, loading } },
      };
    },
    // `tasks` are pages 1 to `page`; with `append` they are page `page`, added below
    setSkypointBoardColumn(state, action) {
      const { status, tasks = [], count = 0, page, append } = action?.payload || {};
      const before = append ? state.skypointBoard[status]?.tasks || [] : [];
      // A task that moved up a page while paging would otherwise show twice
      const seen = new Set();
      const unique = [...before, ...tasks].filter((t) => {
        if (seen.has(t.id)) return false;
        seen.add(t.id);
        return true;
      });
      return {
        ...state,
        skypointBoard: {
          ...state.skypointBoard,
          [status]: {
            tasks: unique,
            count,
            page,
            loading: false,
          },
        },
      };
    },
    resetSkypointBoard(state) {
      return {
        ...state,
        skypointBoard: {},
      };
    },
  },
});

export const {
  setSkypointProjectLoading,
  setSkypointProject,
  setSkypointProjectStatus,
  setSkypointBoardColumnLoading,
  setSkypointBoardColumn,
  resetSkypointBoard,
} = skypointProject.actions;
export default skypointProject.reducer;
